import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// export function dynamicDateRangeValidator(startField: string, endField: string): ValidatorFn {
//   return (group: AbstractControl): ValidationErrors | null => {
//     const start = group.get(startField)?.value;
//     const end = group.get(endField)?.value;

//     if (!start || !end) return null;

//     const startDate = new Date(start);
//     const endDate = new Date(end);

//     return startDate <= endDate
//       ? null
//       : { dateRangeInvalid: 'Start Date must be before End Date' };
//   };
// }

export function dynamicDateRangeValidator(
  relatedControlName: string,
): ValidatorFn {
  return (control: AbstractControl) => {
    if (!control.parent) {
      return null; // Parent form not ready yet
    }

    const relatedControl = control.parent.get(relatedControlName);
    const start = relatedControl?.value;
    const end = control?.value;
    if (!relatedControl) {
      return null; // Related control not found
    }

     if (!start || !end) return null;
     const startDate = new Date(start);
     const endDate = new Date(end);
    return startDate <= endDate
      ? null
      : { dateRange: true };
  };
}
